import { render, staticRenderFns } from "./CreateTicimaxV2Channel.vue?vue&type=template&id=53c9690c&scoped=true"
import script from "./CreateTicimaxV2Channel.vue?vue&type=script&lang=js"
export * from "./CreateTicimaxV2Channel.vue?vue&type=script&lang=js"
import style0 from "./CreateTicimaxV2Channel.vue?vue&type=style&index=0&id=53c9690c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9690c",
  null
  
)

export default component.exports